
import React from 'react';
import { Phone, Mail, MapPin } from 'lucide-react';

interface LocationHeaderProps {
  title: string;
  address: string;
  phone: string;
  email?: string;
  description: string;
}

const LocationHeader: React.FC<LocationHeaderProps> = ({
  title,
  address,
  phone,
  email,
  description
}) => {
  return (
    <div className="text-center mb-12">
      <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
        {title}
      </h2>
      <div className="space-y-2 text-lg">
        <p className="flex items-center justify-center">
          <MapPin className="h-5 w-5 text-primary mr-2" />
          <strong>{address}</strong>
        </p>
        <p className="flex items-center justify-center">
          <Phone className="h-5 w-5 text-primary mr-2" />
          <strong>{phone}</strong>
        </p>
        {email && (
          <p className="flex items-center justify-center">
            <Mail className="h-5 w-5 text-primary mr-2" />
            <strong>{email}</strong>
          </p>
        )}
        <p className="text-gray-600 italic">
          {description}
        </p>
      </div>
    </div>
  );
};

export default LocationHeader;
